import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import { translate } from 'react-polyglot';
import { ToolTip } from '../icons';
import Modal from '../Modal';
import './Text.css';
import { formatContentForReact } from '../globalHelpers';

class Text extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentOpenModal: null
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(evidenceNumber) {
    const evidenceObj = this.props.evidence[evidenceNumber];
    if (evidenceObj) {
      this.setState({
        currentOpenModal: evidenceNumber
      });
    }
  }

  closeModal() {
    this.setState({
      currentOpenModal: null
    });
  }

  render() {
    const { children, evidence, t } = this.props;
    const rootRenderer = rendererProps => (
      <div
        className={classNames(this.props.className, 'edu-text', {
          'edu-text--note': this.props.noteText
        })}
      >
        {rendererProps.children}
      </div>
    );

    const tableRenderer = rendererProps => (
      <div className="edu-table__container">
        <table className="edu-table">{rendererProps.children}</table>
      </div>
    );

    // Hijacking react-markdown's strikethrough renderer
    // to render our evidence modals. Renders strikethrough normally
    // if it doesn't match our evidence regex
    const strikethroughRenderer = rendererProps => {
      const text = rendererProps.children[0];
      const evidenceRegex = /evidence-\d+$/g;
      if (evidenceRegex.test(text)) {
        const evidenceNumber = text.split('-')[1] - 1;
        const evidenceObj = evidence[evidenceNumber];
        const modalContent = evidenceObj && evidenceObj.content;
        return (
          <span>
            <button
              className="edu-text__evidence-button"
              tabIndex="0"
              onKeyPress={() => this.openModal(evidenceNumber)}
              onClick={() => this.openModal(evidenceNumber)}
              title={t('evidenceButton.title')}
            >
              <ToolTip className="edu-text__evidence-icon" />
            </button>
            <Modal
              isOpen={this.state.currentOpenModal === evidenceNumber}
              onRequestClose={this.closeModal}
            >
              {formatContentForReact(modalContent)}
            </Modal>
          </span>
        );
      }

      return <del>{children}</del>;
    };

    return (
      <ReactMarkdown
        source={children}
        renderers={{
          root: rootRenderer,
          delete: strikethroughRenderer,
          table: tableRenderer
        }}
      />
    );
  }
}

Text.defaultProps = {
  evidence: [],
  className: null,
  noteText: false
};

Text.propTypes = {
  children: PropTypes.string.isRequired,
  evidence: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string
    })
  ),
  className: PropTypes.string,
  noteText: PropTypes.bool,
  t: PropTypes.func.isRequired
};

export default translate()(Text);



// WEBPACK FOOTER //
// ./src/components/edu/Text.js